module.exports = __webpack_public_path__ + "img/9791186452097.be17738b.jpg";